import http from "../http-common";

class CompetenciaDataService {
  getAll() {
    return http.get("/competencia");
  }

  // arean1.js // SearchAreaN1.js
  getCompetenciaByDescr(organigramaid, nombrecondition, sortfield, sorttype) {
    return http.get(`/competencia/search/?organigramaId=${organigramaid}&nombrecompetencia=${nombrecondition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/competencia/${id}`);
  }

  create(data) {
    return http.post("/competencia/newcompetencia", data);
  }

  update(id, data) {
    return http.put(`/competencia/${id}`, data);
  }

  delete(id) {
    return http.delete(`/competencia/${id}`);
  }

  deleteAll() {
    return http.delete(`/competencia`);
  }

  findById(id) {
    return http.get(`/competencia?id=${id}`);
  }


  
}

export default new CompetenciaDataService();